<div class="editorial-review">
  <!-- Job control: manual seeding + batch mode -->
  <div class="row g-3 mb-4">
    <div class="col-12 col-lg-5">
      <div class="card p-3 h-100">
        <h6 class="mb-3">Research a plate now</h6>
        <div class="d-flex gap-2">
          <input class="form-control" placeholder="e.g. JK1" [(ngModel)]="seedReg"
                 (keyup.enter)="seed()" />
          <button class="btn btn-primary" (click)="seed()" [disabled]="busy">Research</button>
        </div>
        <small class="text-muted mt-2">Queues a research job; the draft appears below for review.</small>
      </div>
    </div>

    <div class="col-12 col-lg-7">
      <div class="card p-3 h-100">
        <h6 class="mb-3">Batch research</h6>
        <div class="row g-2 align-items-end">
          <div class="col-6 col-md-3">
            <label class="form-label small mb-1">Count</label>
            <input type="number" class="form-control" [(ngModel)]="batchCount" />
          </div>
          <div class="col-6 col-md-3">
            <label class="form-label small mb-1">Min price (£)</label>
            <input type="number" class="form-control" [(ngModel)]="batchMinPrice" placeholder="any" />
          </div>
          <div class="col-6 col-md-3">
            <label class="form-label small mb-1">Sold within (days)</label>
            <input type="number" class="form-control" [(ngModel)]="batchSinceDays" />
          </div>
          <div class="col-6 col-md-3">
            <label class="form-label small mb-1">Style</label>
            <select class="form-select" [(ngModel)]="batchStyle">
              <option value="">any</option>
              <option value="dateless">dateless</option>
              <option value="prefix">prefix</option>
              <option value="suffix">suffix</option>
              <option value="current">current</option>
            </select>
          </div>
        </div>
        <button class="btn btn-outline-primary mt-3 align-self-start" (click)="batch()" [disabled]="busy">
          Enqueue batch
        </button>
      </div>
    </div>
  </div>

  <!-- Status filter + list -->
  <div class="d-flex align-items-center gap-2 mb-3 flex-wrap">
    <span class="fw-semibold me-2">Review queue:</span>
    <button class="btn btn-sm" [ngClass]="statusFilter === EditorialStatus.DRAFT ? 'btn-primary' : 'btn-outline-primary'"
            (click)="statusFilter = EditorialStatus.DRAFT; refresh()">Draft</button>
    <button class="btn btn-sm" [ngClass]="statusFilter === EditorialStatus.CHANGES_REQUESTED ? 'btn-primary' : 'btn-outline-primary'"
            (click)="statusFilter = EditorialStatus.CHANGES_REQUESTED; refresh()">Changes requested</button>
    <button class="btn btn-sm" [ngClass]="statusFilter === EditorialStatus.APPROVED ? 'btn-primary' : 'btn-outline-primary'"
            (click)="statusFilter = EditorialStatus.APPROVED; refresh()">Approved</button>
    <button class="btn btn-sm" [ngClass]="statusFilter === 'all' ? 'btn-primary' : 'btn-outline-primary'"
            (click)="statusFilter = 'all'; refresh()">All</button>
    <button class="btn btn-sm btn-link ms-auto" (click)="refresh()">Refresh</button>
  </div>

  <div *ngIf="loading" class="text-muted">Loading…</div>
  <div *ngIf="!loading && list.length === 0" class="text-muted">No editorials in this state.</div>

  <table *ngIf="!loading && list.length" class="table table-hover align-middle">
    <thead>
      <tr>
        <th>Registration</th>
        <th>Headline</th>
        <th>Status</th>
        <th>Confidence</th>
        <th>Sources</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let a of list">
        <td class="fw-semibold">{{ a.formattedRegistration || a.registration }}</td>
        <td>{{ a.headline }}</td>
        <td><span class="badge bg-secondary">{{ a.status }}</span></td>
        <td><span class="conf-pill" [ngClass]="confidenceClass(a.confidence)">{{ confidenceLabel(a.confidence) }}</span></td>
        <td>{{ (a.sources || []).length }}</td>
        <td><button class="btn btn-sm btn-primary" (click)="open(a)">Review</button></td>
      </tr>
    </tbody>
  </table>

  <!-- Job monitor -->
  <div class="mt-4" *ngIf="jobs.length">
    <h6>Recent research jobs</h6>
    <table class="table table-sm">
      <thead><tr><th>Registration</th><th>Status</th><th>Priority</th><th>Attempts</th><th>Error</th></tr></thead>
      <tbody>
        <tr *ngFor="let j of jobs">
          <td>{{ j.registration }}</td>
          <td>{{ j.status }}</td>
          <td>{{ j.priority }}</td>
          <td>{{ j.attempts }}/{{ j.maxAttempts }}</td>
          <td class="text-danger small">{{ j.lastError }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Review drawer -->
  <div class="review-drawer" *ngIf="selected">
    <div class="review-panel">
      <div class="d-flex align-items-center mb-3">
        <h5 class="mb-0">{{ selected.formattedRegistration || selected.registration }}</h5>
        <span class="conf-pill ms-3" [ngClass]="confidenceClass(selected.confidence)">
          overall {{ confidenceLabel(selected.confidence) }}
        </span>
        <button class="btn btn-sm btn-link ms-auto" (click)="close()">Close</button>
      </div>

      <div *ngIf="hasUnsourcedClaims()" class="alert alert-warning py-2">
        One or more claims have no backing source. Approval is blocked until every claim cites a source.
      </div>

      <label class="form-label small mb-1">Headline</label>
      <input class="form-control mb-3" [(ngModel)]="selected.headline" />

      <label class="form-label small mb-1">Summary</label>
      <textarea class="form-control mb-3" rows="3" [(ngModel)]="selected.summary"></textarea>

      <label class="form-label small mb-1">Body (markdown)</label>
      <textarea class="form-control mb-3" rows="8" [(ngModel)]="selected.bodyMarkdown"></textarea>

      <h6 class="mt-3">Claims &amp; evidence</h6>
      <div class="claim" *ngFor="let c of selected.claims">
        <div class="d-flex align-items-start gap-2">
          <span class="conf-pill" [ngClass]="confidenceClass(c.confidence)">{{ confidenceLabel(c.confidence) }}</span>
          <div class="flex-fill">
            <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="c.text"></textarea>
            <div *ngIf="c.uncertaintyNote" class="text-warning small mt-1">⚠ {{ c.uncertaintyNote }}</div>
            <div class="sources mt-2">
              <div class="source" *ngFor="let s of sourcesFor(c)">
                <a [href]="s.url" target="_blank" rel="noopener noreferrer">{{ s.title || s.url }}</a>
                <span class="badge bg-light text-dark ms-1">{{ s.sourceType }}</span>
                <span class="text-muted small ms-1">{{ s.dateAccessed | date }}</span>
              </div>
              <div class="text-danger small" *ngIf="sourcesFor(c).length === 0">No source linked.</div>
            </div>
          </div>
        </div>
      </div>

      <label class="form-label small mb-1 mt-3">Reviewer notes</label>
      <textarea class="form-control mb-3" rows="2" [(ngModel)]="selected.reviewerNotes"></textarea>

      <div class="d-flex gap-2 flex-wrap">
        <button class="btn btn-outline-secondary" (click)="saveEdits()" [disabled]="busy">Save edits</button>
        <button class="btn btn-success" (click)="approve()" [disabled]="busy || hasUnsourcedClaims()">Approve &amp; publish</button>
        <button class="btn btn-outline-warning" (click)="requestChanges()" [disabled]="busy">Request changes</button>
        <button class="btn btn-outline-primary" (click)="requestReResearch()" [disabled]="busy">Re-research</button>
        <button class="btn btn-outline-danger ms-auto" (click)="reject()" [disabled]="busy">Reject</button>
      </div>
    </div>
  </div>
</div>
